export class AircraftInspection {
  id: number;
  answerRequired: boolean;
  description: string;
  pictureRequired: boolean;
  pass: boolean;
}
